/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Area } from "./modelArea";

class ControllerArea extends ControllerModel {
  constructor(areaName) {
    super("ControllerArea");
    
    this.setNewNode = (callback, callback2) => {
      let area = new Area(areaName);
      area.decorate(callback, callback2);

      this.addNode(area);
    }

    this.loadNode = async (node, callback, callback2) => {
      let area = new Area(areaName);
      area.copyFrom(node);
      await area.decorate(callback, callback2);
      this.addNode(area)
    }

    this.getProperties = async (node) => {
      let n = new Area(areaName);
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Area(areaName);
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerArea };
